import React from "react";
import { Box, Typography, Card, CardContent, IconButton, TextField, Button } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { WebAuthnDevice } from "src/store/features/api/generated";
import { formatDistanceToNow } from "date-fns";

interface MobilePasskeyViewProps {
  devices: WebAuthnDevice[];
  editingId: string | null;
  editName: string;
  onEditClick: (device: WebAuthnDevice) => void;
  onSaveEdit: () => void;
  onCancelEdit: () => void;
  onEditNameChange: (value: string) => void;
  onRemoveClick: (id: string) => void;
  isUpdatingDevice: boolean;
  isDeletingDevice: boolean;
}

export const MobilePasskeyView: React.FC<MobilePasskeyViewProps> = ({
  devices,
  editingId,
  editName,
  onEditClick,
  onSaveEdit,
  onCancelEdit,
  onEditNameChange,
  onRemoveClick,
  isUpdatingDevice,
  isDeletingDevice,
}) => {
  const renderDeviceCard = (device: WebAuthnDevice) => (
    <Card key={device.id} sx={{ mb: 2, borderRadius: 2 }}>
      <CardContent>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            mb: 1,
          }}>
          {editingId === device.id ? (
            <Box sx={{ flex: 1, mr: 1 }}>
              <TextField
                fullWidth
                size="small"
                value={editName}
                onChange={(e) => onEditNameChange(e.target.value)}
                autoFocus
              />
            </Box>
          ) : (
            <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
              {device.displayName || device.browser}
            </Typography>
          )}
          <Box>
            {editingId === device.id ? (
              <>
                <Button
                  size="small"
                  onClick={onSaveEdit}
                  disabled={isUpdatingDevice}
                  sx={{ mr: 1 }}>
                  Save
                </Button>
                <Button size="small" onClick={onCancelEdit} color="inherit">
                  Cancel
                </Button>
              </>
            ) : (
              <>
                <IconButton size="small" onClick={() => onEditClick(device)} sx={{ mr: 1 }}>
                  <EditIcon fontSize="small" />
                </IconButton>
                <IconButton
                  size="small"
                  onClick={() => onRemoveClick(device.id)}
                  disabled={isDeletingDevice}>
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </>
            )}
          </Box>
        </Box>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
          First seen: {formatDistanceToNow(new Date(device.first_seen))} ago
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Last seen: {formatDistanceToNow(new Date(device.last_seen))} ago
        </Typography>
      </CardContent>
    </Card>
  );

  return (
    <Box sx={{ mt: 2 }}>{devices.length > 0 && <Box>{devices.map(renderDeviceCard)}</Box>}</Box>
  );
};
